// Platform session idle timeout (user-management signs sessions out after 30
// minutes without activity; the dashboard mirrors it with a warning first).
// Kept in step with go-cinnte-portal's utils/sessionIdle.ts.

export const DEFAULT_IDLE_TIMEOUT_SECONDS = 30 * 60;

/** How long before the sign-out the "Are you still there?" warning appears. */
export const IDLE_WARNING_MS = 5 * 60 * 1000;

/** localStorage key for the last user activity, shared by every tab. */
export const SESSION_ACTIVITY_STORAGE_KEY = 'kyp.admin.session.lastActivity';

const LOGOUT_REASON_KEY = 'kyp.admin.session.logoutReason';

/** ⛔ Must match exception.SessionIdleMessage in user-management. */
export const SESSION_IDLE_MESSAGE = 'Your session expired due to inactivity. Please sign in again';

// Why the user was signed out without asking: inactivity, or KYP staff refused
// their access (client suspended / account blocked).
export type LogoutReason = 'idle' | 'suspended' | 'blocked';

export function setLogoutReason(reason: LogoutReason) {
  try {
    window.sessionStorage.setItem(LOGOUT_REASON_KEY, reason);
  } catch {
    /* storage unavailable: the sign-in page just won't explain why */
  }
}

export function setIdleLogoutReason() {
  setLogoutReason('idle');
}

/** Reads and clears why the user was last signed out. */
export function takeLogoutReason(): LogoutReason | null {
  try {
    const reason = window.sessionStorage.getItem(LOGOUT_REASON_KEY);
    window.sessionStorage.removeItem(LOGOUT_REASON_KEY);
    return reason === 'idle' || reason === 'suspended' || reason === 'blocked' ? reason : null;
  } catch {
    return null;
  }
}

/** True once if the last sign-out was for inactivity (then cleared). */
export function takeIdleLogoutReason(): boolean {
  return takeLogoutReason() === 'idle';
}
